<script>
import CustomCommonConfig from './CustomCommonConfig';
import validateFieldsMixin from '@/mixins/validateFields.mixin';
export default {
  extends: CustomCommonConfig,
  mixins: [validateFieldsMixin],
  emits: ['update:changeField'],
  data() {
    return {
      configTitle: this.$t('title.currentStatusIndex'), // 위젯 config 타이틀
      useTargetsMethod: true, // 통계설정 화면 display 여부
      targetsMethodModel: 'avg', // 통계설정 default value
      useThresholdValue: true, // 위험도 설정 화면 display 여부
      defaultConfig: this.config({
        // 위젯 설정 정보
        isResizable: true,
        w: 1,
        h: 1,
        minW: 1,
        maxW: 8,
        minH: 1,
        maxH: 6,
        widget: {
          type: 'StatusMetricWidget',
          api: '/cloudmonitorings/product/v1/console/metric-data-method',
          options: {}
        }
      }),
      validateFieldKey: 'statusMetricWidgetConfig'
    };
  },
  watch: {
    changedFieldData: {
      handler(value) {
        this.$emit('update:changeField', value);
      },
      immediate: true
    }
  },
  methods: {
    updateFieldsBeforeModify() {
      this.setFieldsBeforeModify();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './styles/customCommonConfig.scss';
</style>
